import React from 'react';
import _ from 'lodash';

import {SelectInput} from 'src/design-system';

const RepeatOccurrencesInput = () => {
  return (
    <SelectInput
      valueKey={'repeatOccurrences'}
      name={'Occurrences'}
      required={true}
      items={_.range(1, 100).map(idx => {
        return {label: idx.toString(), value: idx.toString()};
      })}
    />
  );
};

export const Input = RepeatOccurrencesInput;

export default RepeatOccurrencesInput;
